// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const InputIcon = createStyle({
  variants: BaseIconVariants,
  props: {
    size: 'md',
  },
});
